import React from 'react';

import Embed from '../common/Embed.jsx';

function VideoComponent(props) {
    let url;
    if (props.blockConfig && props.blockConfig.block) {
        url = props.blockConfig.block.url;
        let isVimeo, isYouTube;
        var youRegex = /^http[s]?:\/\/(((www.youtube.com\/watch\?(feature=player_detailpage&)?)v=)|(youtu.be\/))([^#\&\?]*)/;
        var vimeoRegex = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/)|(video\/))?([0-9]+)\/?/;
        var vimeoPrivateRegex = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/)|(video\/))?([0-9]+)\/([0-9A-z]+)\/?/;
        var youRegexMatches = youRegex.exec(url);
        var vimeoRegexMatches = vimeoRegex.exec(url);
        var vimeoPrivateRegexMatches = vimeoPrivateRegex.exec(url);
        if (youRegexMatches != null || vimeoRegexMatches != null || vimeoPrivateRegexMatches != null) {
            if (youRegexMatches != null && youRegexMatches.length >= 7) {
                var youMatch = youRegexMatches[6];
                url = '//www.youtube.com/embed/' + youMatch + '?rel=0';
                isYouTube = true;
            }
            else if (vimeoPrivateRegexMatches != null && vimeoPrivateRegexMatches.length >= 7) {
                var vimeoMatch = vimeoPrivateRegexMatches[6];
                var vimeoPrivateMatch = vimeoPrivateRegexMatches[7];
                url = '//player.vimeo.com/video/' + vimeoMatch + '?h=' + vimeoPrivateMatch;
                isVimeo = true;
            }
            else if (vimeoRegexMatches != null && vimeoRegexMatches.length >= 7) {
                var vimeoMatch = vimeoRegexMatches[6];
                url = '//player.vimeo.com/video/' + vimeoMatch;
                isVimeo = true;
            }
        }
        let extras, mutePropName;
        if (isYouTube || url && url.indexOf('youtube.com/embed') >= 0) {
            extras = [];
            mutePropName = 'mute';
            isYouTube = true;
        } else if (isVimeo || url && url.indexOf('vimeo.com/video') >= 0) {
            extras = [];
            mutePropName = 'muted';
        }
        if (extras) {
            if (props.blockConfig.block.autoplay) {
                extras.push(`autoplay=1&${mutePropName}=1`);
            }
            if (props.blockConfig.block.hideControls) {
                extras.push('controls=0');
            }
            if (props.blockConfig.block.loop) {
                extras.push('loop=1');

                if (isYouTube) {
                    youRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi
                    youRegexMatches = youRegex.exec(url);
                    if (youRegexMatches != null && youRegexMatches.length >= 1) {
                        extras.push(`playlist=${youRegexMatches[1]}`)
                    }
                }
            }
            if (extras.length) {
                if (url.indexOf('?') > 0) {
                    url += '&';
                } else {
                    url += '?';
                }
                url += extras.join('&');
            }
        }
    }
    return <Embed.Component {...props} className="video__cont" embedType="video" url={url} />
}

export default { Component: VideoComponent };